import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useCustom from "./customHook/customHook";
import NewNotiSettings from './components/NewNotiSettings';
import NewsNoti from "./components/NewsNoti";
import bell_icon from './image/bell.jpg'
import home_icon from './image/home.jpg'
import header_image from './image/header_image.png'
import './App.css';
import liff from '@line/liff';

const App = () => {
  const [globalState, setGlobalState] = useCustom();
  const [currentMenu, setCurrentMenu] = useState("setting");

  const handleChangeMenu = (memu) => {
    if (memu == "setting") {
      document.getElementById("line-user-profile").className = "menu-selected";
      document.getElementById("noti").className = "menu";
    } else {
      document.getElementById("noti").className = "menu-selected";
      document.getElementById("line-user-profile").className = "menu";
    }
    setCurrentMenu(memu);
  };

  return (
    <>
      <div className='container-app-header'>
        <div className='menu'>
          <img style={{ width: "32px", height: "32px" }} src={home_icon} onClick={() => liff.closeWindow()}/>
        </div>
        <div className='dummy'>
          <div style={{ width: "50px" }}></div>
        </div>
        <div className='dummy'>
          <div style={{ width: "50px" }}></div>
        </div>
        <div className='dummy'>
          <div style={{ width: "50px" }}></div>
        </div>
        <div className='menu' id='noti' onClick={() => handleChangeMenu('noti')}>
          <img style={{ width: "32px", height: "32px" }} src={bell_icon}/>
        </div>
        <div className="menu-selected" id='line-user-profile' onClick={() => handleChangeMenu('setting')}>
          <img style={{ width: "32px", height: "32px", borderRadius: "32px" }} src={globalState.line_user_profile}/>
        </div>
      </div>
      {/*<div className="container-banner">
          <span style={{ display: "flex", justifyContent: "center" }}>
            <span className='text-header'>เปิดการแจ้งเตือน&nbsp;</span>
            <span className='text-header-highlight'>ข่าวสารดี</span>
          </span>
          <span style={{ display: "flex", justifyContent: "center" }}>
            <span className='text-sub-header'>รับข่าวสารที่เป็นประโยชน์ก่อนใคร รวดเร็ว ทันใจ</span>
          </span>
          <span style={{ display: "flex", justifyContent: "center" }}>
            <span className='text-sub-header'>เพียง</span>
            <span className='text-sub-header-highlight'>เพิ่มการแจ้งเตือน</span>
            <span className='text-sub-header-highlight-2nd'>และปักหมุดพื้นที่ที่สนใจ</span>
          </span>
          <img src={header_image} className="bottom-right-image" />
      </div>*/}
      {globalState.isShowBanner &&
        <div className="banner"></div>
      }
      <>
      {currentMenu == 'setting' &&
        <NewNotiSettings />
      }
      {currentMenu == 'noti' &&
        <NewsNoti/>
      }
      </>
    </>
  );
};

export default App;